import React from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Inline, xcss } from '@atlaskit/primitives';
import NodeIcon from '@atlaskit/icon/core/node';
import { LinkMenuItem } from '@atlaskit/side-nav-items/link-menu-item';

import { useHardStorageEnforcement } from '@confluence/storage-enforcement/entry-points/HardEnforcement/useHardStorageEnforcement.ts';
import { ContentIcon } from '@confluence/icons/entry-points/ContentIcon.ts';

export const SOURCE_NAME = 'contentTreeOnboarding';

const onboardingItemContainer = xcss({
	marginLeft: 'space.025',
});

type ContentTreeOnboardingItemProps = React.PropsWithChildren<{
	contentType: string;
	subType?: string;
	href: string;
	iconGlyph: React.ReactNode;
}>;

export const ContentTreeOnboardingItem = ({
	children,
	contentType,
	subType,
	href,
}: ContentTreeOnboardingItemProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { enforceStorageLimit, shouldBlockCreate } = useHardStorageEnforcement({
		source: 'contentTreeOnboarding',
	});

	const onClick = () => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: 'contentTreeOnboardingItem',
				source: SOURCE_NAME,
				attributes: {
					contentType,
					subType,
				},
			},
		}).fire();
	};

	return (
		<LinkMenuItem
			elemBefore={<NodeIcon label="" />}
			href={shouldBlockCreate ? '#' : href}
			onClick={enforceStorageLimit(onClick)}
		>
			<Inline space="space.100" alignBlock="center" xcss={onboardingItemContainer}>
				<ContentIcon type={contentType} subType={subType} />
				{children}
			</Inline>
		</LinkMenuItem>
	);
};
